module.exports = __webpack_public_path__ + "img/popup4.36abf7ad.png";